<div *ngIf="poolInPerOpDays">
    <div class="body-b">
        <p>Pool in <ng-container *ngIf="forTooltip">($)</ng-container></p>
        <hr>
        <p>Operating days </p>
    </div>
</div>
<div *ngIf="relativeShareInPool">
    <div class="body-b">
        <p>Operating days × Pool pts</p>
        <hr>
        <!-- <p>∑(Operating days × Pool pts) per ship in Pool</p> -->
         <p>∑(Operating days × Pool pts) for all ships in Pool</p>
    </div>
</div>
<div *ngIf="poolOut">
    <div class="body-b">
        <p>Gross distribution <ng-container *ngIf="forTooltip">($)</ng-container></p>
        <hr>
        <p>Operating days</p>
    </div>
</div>
<div *ngIf="netPoolOutPerOpDays">
    <div class="body-b">
        <p>Net pool out <ng-container *ngIf="forTooltip">($)</ng-container></p>
        <hr>
        <p>Operating days</p>
    </div>
</div>

<div class="box" *ngIf="grossDistribution">
    <div [ngClass]="forTooltip ? 'square-bracket-tooltip' : 'square-bracket'">
        <p>
            Total Pool in <ng-container *ngIf="forTooltip">($)</ng-container> of Pool {{poolName}}<br>
            + Shared pool expenses <ng-container *ngIf="forTooltip">($)</ng-container> of Pool {{poolName}}<br>
            - Scrubber savings <ng-container *ngIf="forTooltip">($)</ng-container> of Pool {{poolName}}<br>
            - LNG savings <ng-container *ngIf="forTooltip">($)</ng-container> of Pool {{poolName}}<br>
        </p>
    </div>
    <br>
    <p> × Relative share in pool <ng-container *ngIf="forTooltip">(%)</ng-container></p>
</div>

<div class="box" *ngIf="profitSharing">
    <div class="square-bracket">
        <p>
            Net pool out ($/Op.day)<br>
            - Profit sharing threshold
        </p>
    </div>
    <br>
    <p>× Profit sharing rate</p>
    <p>× Operating days</p>
    <p *ngIf="note"><span class="caption note-style">*Profit sharing is calculated <br/>
         and will be displayed in May and <br/>
         November.</span></p>

</div>

<div *ngIf="bunkerProcurementFee">
    <p class="body-b" *ngIf="forTooltip">
        BFB consumption (MT) × procurement fee ($)<br>
        + IFO consumption (MT) × procurement fee ($)<br>
        + LSF consumption (MT) × procurement fee ($)<br>
        + MGO consumption (MT) × procurement fee ($)<br>
    </p>
    <p class="body-b" *ngIf="forFormula">
        (consumption × procurement fee)<br>
        BFB<br>
        + IFO<br>
        + LSF<br>
        + MGO<br>
    </p>
</div>

<div *ngIf="finalPayout">
    <p class="body-b">
        Net pool out <ng-container *ngIf="forTooltip">($)</ng-container><br>
        - Profit share<br>
        + Scrubber & LNG savings<br>
    <p *ngIf="note" class="truncate-txt note-style">
        <span class="caption note-style">*Only applicable for ships <br/>
            who receive profit share and/ <br/>
            or scrubber & LNG savings
        </span>
    </p>
</div>

<div *ngIf="overheadfee">
    <p class="body-b">
        Daily overhead rate of Pool {{poolName}}<ng-container *ngIf="forTooltip">($)</ng-container><br>
        × Calendar days
    </p>
</div>

<div *ngIf="commissionFee">
    <p class="body-b">
        Fleet commission %<br>
        × Total Gross revenue <ng-container *ngIf="forTooltip">($)</ng-container> of Pool {{poolName}}<br>
        × Relative share in pool <ng-container *ngIf="forTooltip">(%)</ng-container><br>
    </p>
</div>
<div *ngIf="managementfee">
    <p class="body-b">
        Overhead fee <ng-container *ngIf="forTooltip">($)</ng-container><br>
        + Commission fee <ng-container *ngIf="forTooltip">($)</ng-container><br>
        + Bunker procurement fee <ng-container *ngIf="forTooltip">($)</ng-container>
    </p>
</div>

<div *ngIf="netPoolOut">
    <p class="body-b">
        Gross distribution <ng-container *ngIf="forTooltip">($)</ng-container><br>
        - Management fee <ng-container *ngIf="forTooltip">($)</ng-container><br>
    </p>
</div>
<div *ngIf="totalScrubberSavings">
    <p class="body-b">
        Total IFO consumption <ng-container *ngIf="forTooltip">(MT)</ng-container><br>
        × [({{bunkerConsMultiLSF}} × average price of LSF)<br>
        + ({{bunkerConsMultiMGO}} × average price of MGO)]<br>
        - Total IFO cost <ng-container *ngIf="forTooltip">($)</ng-container><br>
    </p>
</div>
 
<div *ngIf="totalIfoConsumption">
    <p class="body-b">
        Actual IFO consumption <ng-container *ngIf="forTooltip">(MT)</ng-container><br>
        - Previous year's recognised IFO consumption <ng-container *ngIf="forTooltip">(MT)</ng-container>
    </p>
</div>
<div *ngIf="totalIfoConsumptionSidePanel">
    <p class="body-b">
        Actual IFO consumption <ng-container *ngIf="forTooltip">(MT)</ng-container><br>
        - Previous year's recognised consumption <ng-container *ngIf="forTooltip">(MT)</ng-container>
    </p>
</div>
<div *ngIf="totalIfoCost">
    <p class="body-b">
        Actual IFO cost <ng-container *ngIf="forTooltip">($)</ng-container><br>
        - Previous year's recognised IFO cost <ng-container *ngIf="forTooltip">($)</ng-container>
    </p>
</div>
 
<div *ngIf="scrubberSavings">
    <div class="body-b">
        <span>Scrubber days × Scrubber pts</span>
        <hr>
        <span>∑(Scrubber days × Scrubber pts) of all ships</span><br>
        <span class="totalScrubberText">× Total scrubber savings</span>
    </div>
</div>
<div *ngIf="lngSavings">
    <div class="body-b">
        <span>Op. days</span>
        <hr>
        <span>Total op. days of all ships</span><br>
        <span>× Total LNG savings</span>
    </div>
</div>